import { render } from "./RoomStatusIndex.vue?vue&type=template&id=6d4dea24"
import script from "./RoomStatusIndex.vue?vue&type=script&lang=js"
export * from "./RoomStatusIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__